import { CONFIG, ENUMS } from './wiki';
import { generateState } from './utils';

export const state = () => ({
  // parameters
  mode: 'request',
  // model
  currentStatus: { id: 'NONE' },
  currentStatusTarget: null,
  currentTab: ENUMS.TABS['Analisis Escuela'],
  // catalog
  statusTargets: [],
  // states
  tabsState: generateState({
    config: CONFIG.STATUS.NONE.request,
    status: null,
  }),
  approvalInfo: { academicYear: null, determination: null },
  // request type
  requestTypeId: ENUMS.REQUEST_TYPE.NUEVO,
});
